import { __assign } from 'tslib';
import Vue from 'vue';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

var GITHUB_BASE_URL = 'https://github.com';
var script = Vue.extend({
  name: 'GitHubCorners',
  props: {
    repo: {
      type: String,
      required: true
    },
    blank: {
      type: Boolean,
      default: true
    },
    bgColor: {
      type: String,
      default: '#151513'
    },
    color: {
      type: String,
      default: '#fff'
    },
    position: {
      type: String,
      default: 'right',
      validator: function validator(value) {
        return value === 'left' || value === 'right';
      }
    }
  },
  computed: {
    url: function url() {
      return GITHUB_BASE_URL + "/" + this.repo;
    },
    svgStyle: function svgStyle() {
      var positionStyles = {};

      if (this.position === 'left') {
        positionStyles = {
          left: 0,
          transform: 'scale(-1, 1)'
        };
      } else {
        positionStyles = {
          right: 0
        };
      }

      return __assign({
        fill: this.bgColor,
        color: this.color,
        position: 'absolute',
        border: 0,
        top: 0
      }, positionStyles);
    },
    blankAttr: function blankAttr() {
      return this.blank ? '_blank' : null;
    },
    relAttr: function relAttr() {
      return this.blank ? 'noopener noreferrer' : null;
    }
  }
});

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"github-corner",attrs:{"href":_vm.url,"target":_vm.blankAttr,"rel":_vm.relAttr,"aria-label":"View source on GitHub"}},[_c('svg',{style:(_vm.svgStyle),attrs:{"width":"80","height":"80","viewBox":"0 0 250 250","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z"}}),_vm._v(" "),_c('path',{staticClass:"octo-arm",staticStyle:{"transform-origin":"130px 106px"},attrs:{"d":"M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2","fill":"currentColor"}}),_vm._v(" "),_c('path',{staticClass:"octo-body",attrs:{"d":"M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z","fill":"currentColor"}})])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var GitHubCorners = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

function install(vue) {
  vue.component('github-corners', GitHubCorners);
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

var index = {
  install: install
};

export default index;
//# sourceMappingURL=vue-github-corners.esm.mjs.map
